import { render, staticRenderFns } from "./PageProfileEditView.vue?vue&type=template&id=2d10c72e&scoped=true&"
import script from "./PageProfileEditView.vue?vue&type=script&lang=ts&"
export * from "./PageProfileEditView.vue?vue&type=script&lang=ts&"
import style0 from "./PageProfileEditView.vue?vue&type=style&index=0&id=2d10c72e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d10c72e",
  null
  
)

export default component.exports